(function($, undefined) {
	'use strict';

	var updateBgPosLabel = function() {
		var t = $(this);
		var value = t.val() + "%";
		var key = t.data('key');

		var langs = $('html').attr('data-all-langs');
		updateLabelLangs(key, value, langs, function() {}, true);
	};

	var changeBgPos = function() {
		var t = $(this);
		var ctn = $('.background-img-' + t.attr('data-id'));
		var currentPosition = ctn.css('backgroundPosition');
		var value = t.val();
		var otherVal;

		// change background
		if (t.hasClass('horizontal')) {
			otherVal = currentPosition.split('% ');
			ctn.css('backgroundPosition', value + '% ' + otherVal[1]);
		} else if (t.hasClass('vertical')) {
			otherVal = currentPosition.split(' ');
			ctn.css('backgroundPosition', otherVal[0] + ' ' + value + '%');
		}
	};

	var toggleElement = function() {
		var t = $(this);
		var ctn = t.closest('.toggle-outer-ctn');
		var el = ctn.find('.element-to-toggle');

		if (el.css('display') === 'block' && el.find('input, select').hasClass('required')) {
			el.find('input.required, select.required').removeClass('required').addClass('derequired');
		} else if (el.css('display') !== 'block' && el.find('input, select').hasClass('derequired')) {
			el.find('input.derequired, select.derequired').removeClass('derequired').addClass('required');
		}

		ctn.toggleClass('open');
		el.slideToggle();
	};

	var init = function() {
		var bgPosRange = $('.image-bg-pos');

		$('.toggle-trigger-element').click(toggleElement);
		bgPosRange.on('change', updateBgPosLabel);
		bgPosRange.on('input', changeBgPos);
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

